module.exports = __webpack_public_path__ + "static/media/upload_video_youtube.5187a3a3.png";